// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4120":"6724c6a9","8749":"fe623412","9711":"a821fc80"}[chunkId] + ".chunk.css";
};